import { Tween } from '@tweenjs/tween.js';
import { degToRad } from 'three/src/math/MathUtils';
import { Rotation, Sweep } from '@/_models/Sweep';

export class VRCameraController {
  THREE: any;

  renderer: any;

  camera: any;

  cameraPose: any;

  baseReferenceSpace: any;

  constructor(THREE, renderer, camera, cameraPose) {
    this.THREE = THREE;
    this.renderer = renderer;
    this.camera = camera;
    this.cameraPose = cameraPose;
  }

  // rotate VR view based on camera sweep and object for camera to look at
  rotateVRView(targetSweep: Sweep, targetObj) {
    if (!this.baseReferenceSpace) {
      this.baseReferenceSpace = this.renderer.xr.getReferenceSpace();
    }

    const transform2 = new XRRigidTransform(new this.THREE.Vector3(), {
      x: 0,
      y: 0,
      z: 0,
      w: 1,
    });
    const teleportSpaceOffset2 = this.baseReferenceSpace.getOffsetReferenceSpace(transform2);
    this.renderer.xr.setReferenceSpace(teleportSpaceOffset2);
    setTimeout(() => {
      const posAvatar = new this.THREE.Vector3();
      this.camera.getWorldPosition(posAvatar);

      const posObj = new this.THREE.Vector3();
      if (targetObj) targetObj.getWorldPosition(posObj);
      else if (
        targetObj.hasOwnProperty('positionX') &&
        targetObj.hasOwnProperty('positionY') &&
        targetObj.hasOwnProperty('positionZ')
      ) {
        posObj.set(targetObj.position.x, targetObj.position.y, targetObj.position.z);
      }

      const xDist = posObj.x - posAvatar.x;
      const zDist = posObj.z - posAvatar.z;
      const angle = Math.atan2(zDist, xDist);

      const quaternion = new this.THREE.Quaternion();
      quaternion.setFromAxisAngle(
        new this.THREE.Vector3(0, 1, 0),
        degToRad(this.cameraPose.current.rotation.y) + angle + Math.PI / 2,
      );

      const transform = new XRRigidTransform(new this.THREE.Vector3(), {
        x: quaternion.x,
        y: quaternion.y,
        z: quaternion.z,
        w: quaternion.w,
      });
      const teleportSpaceOffset = this.baseReferenceSpace.getOffsetReferenceSpace(transform);
      this.renderer.xr.setReferenceSpace(teleportSpaceOffset);
    }, 300);
  }

  // Create helper object based on target camera rotation direction then rotate VR view
  rotateVRViewByCameraRotation(targetSweep: Sweep, rotation: Rotation) {
    const vec = this.getDirectionFromRotation(rotation.x, rotation.y);
    const geometry = new this.THREE.SphereGeometry(0.3, 32, 16);
    const material = new this.THREE.MeshBasicMaterial({ color: 0xffff00 });
    const sphere = new this.THREE.Mesh(geometry, material);
    sphere.visible = false;
    sphere.position.set(
      targetSweep.position.x + vec.x,
      targetSweep.position.y + vec.y,
      targetSweep.position.z + vec.z,
    );
    this.camera.parent.parent.add(sphere);
    sphere.userData = { temp: true };
    this.rotateVRView(targetSweep, sphere);
  }

  getDirectionFromRotation(rotationX: number, rotationY: number) {
    const forward = new this.THREE.Vector3(0, 0, -1);
    const euler = new this.THREE.Euler(
      this.THREE.MathUtils.degToRad(rotationX),
      this.THREE.MathUtils.degToRad(rotationY),
      0,
      'YXZ',
    );
    forward.applyEuler(euler);
    return forward;
  }
}
